module.exports = __webpack_public_path__ + "img/icon_support_01.42516aa2.png";